var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
/**
 * @deprecated Use the Wave component in `ffe-shapes-react` instead.
 */
export function Wave(_a) {
    var _b, _c;
    var position = _a.position, flip = _a.flip, color = _a.color, darkmodeColor = _a.darkmodeColor, bgColor = _a.bgColor, bgDarkmodeColor = _a.bgDarkmodeColor, children = _a.children, className = _a.className, rest = __rest(_a, ["position", "flip", "color", "darkmodeColor", "bgColor", "bgDarkmodeColor", "children", "className"]);
    return (React.createElement("div", { className: classNames('ffe-wave', className, (_b = {},
            _b["ffe-wave--bg-".concat(bgColor)] = bgColor,
            _b["ffe-wave--dm-bg-".concat(bgDarkmodeColor)] = bgDarkmodeColor,
            _b)) },
        children ? (React.createElement("div", { className: "ffe-wave__content" }, children)) : null,
        React.createElement("div", __assign({ className: classNames('ffe-wave__wave', "ffe-wave--bg-".concat(color), (_c = {},
                _c["ffe-wave--dm-bg-".concat(darkmodeColor)] = darkmodeColor,
                _c['ffe-wave__wave--flip'] = flip,
                _c)), "aria-hidden": "true", style: {
                maskPosition: position,
                WebkitMaskPosition: position,
            } }, rest))));
}
